<template>
  <div>
    <div class="vx-row container mb-4">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
      >
        <div class="header">
          <div class="details-header2 flex justify-between items-center">
            <h2 class="text-white">
              {{ $t("customers.label.Select_a_Monthly_Plan") }}
            </h2>
            <div class="my-search-box">
              <div class="con-input-search vs-table--search">
                <input
                  type="text"
                  v-model="searchQuery"
                  class="input-search vs-table--search-input"
                  :placeholder="$t('customers.label.Search_plans')"
                />
                <i class="vs-icon notranslate icon-scale material-icons null">{{
                  $t("customers.label.search")
                }}</i>
              </div>
            </div>
          </div>
          <!-- <vs-tabs
            v-model="selectedTab"
            alignment="fixed"
            class="tab-action-btn-fill-conatiner"
          >
            <vs-tab label="Bundle Plan"></vs-tab>
            <vs-tab label="Addon"></vs-tab>
          </vs-tabs> -->
        </div>
        <div class="plans vx-card p-3" v-if="selectedTab === 0">
          <div
            v-for="(pricing, index) in filteredPlans"
            :key="index"
            class="mb-4"
            @click="setPlan(pricing, index)"
          >
            <PricingCard
              :data="pricing"
              :contentData="contentData"
              :selectedPlanProp="selectedPlan"
              :type="basketData.simType"
              @planClicked="planSelected"
            />
          </div>
          <span style="color: red" v-if="nextClicked && !selectedPlan">{{
            $t("customers.label.Select_a_plan")
          }}</span>
        </div>

        <!-- <div class="mt-3" v-if="selectedTab === 1">
          <div>
            <div class="vx-row mb-4 mt-4">
              <div
                class="flex vx-col w-full md:w-full"
                v-for="(chunk, index) in chunkedCategoryData"
                :key="index"
              >
                <vs-checkbox
                  v-for="item in chunk"
                  :key="item.id"
                  v-model="selectedCategories[item.mCodeValue]"
                  class="mb-3"
                  color="success"
                >
                  {{ item.mCodeValue }}
                </vs-checkbox>
              </div>
            </div>
            <div
              v-for="(pricing, index) in filteredPlans"
              :key="index"
              class="mb-4"
            >
              <PricingCard
                :data="pricing"
                :contentData="contentData"
                :selectedAddonProp="selectedAddon"
                @planClicked="addonSelected"
              />
            </div>
          </div>
        </div> -->
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
      >
        <div class="">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="header">
                <div class="details-header2 flex items-center">
                  <img src="@/assets/images/pages/basketIcon.svg" />
                  <h3 class="ml-3 text-white">
                    {{ $t("customers.label.Basket") }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-card p-2">
            <div
              class="p-2"
              :style="
                (basketData && basketData.pairedItemSerialNumber) ||
                (basketData && basketData.serialNumber.length > 14)
                  ? {
                      border:
                        elapsedTime > 59
                          ? '4px solid #00FF00'
                          : '4px solid #FF0000',
                    }
                  : {}
              "
            >
              <span
                class="font-bold flex items-center justify-between"
                v-if="
                  (basketData && basketData.itemSerialNumber) ||
                  (basketData && basketData.serialNumber.length > 14)
                "
              >
                {{ $t("customers.label.This_number_is_reserved_for") }}
                <Timer
                  @update-timer="updateElapsedTime"
                  :elapsedTime="elapsedTime"
                />
              </span>
              <p class="mb-2 text-success">
                ✅ You Selected {{ basketData.selectedSimText }}
              </p>
              <!-- <p v-if="basketData.itemSerialNumber" class="mb-2 text-success">
                ✅ Serial No - {{ basketData.itemSerialNumber }}
              </p>
              <p
                v-if="basketData.pairedItemSerialNumber"
                class="mb-2 text-success"
              >
                ✅ Phone No - {{ basketData.pairedItemSerialNumber }}
              </p> -->
              <p class="mb-2 text-success">
                ✅ Serial No -
                {{ basketData.itemSerialNumber || basketData.serialNumber }}
              </p>
              <p class="mb-2 text-success">
                ✅ Phone No -
                {{
                  basketData.phoneNumber || basketData.pairedItemSerialNumber
                }}
              </p>
            </div>
            <basket
              v-for="(data, i) in planData"
              :key="i"
              title="Bundle"
              :detailsHtml="data.text"
              :discountedPrice="data.finalPrice"
              :currencySymbol="data.currencySymbol"
              :originalPrice="data.price"
              :discountRate="data.rate"
              buttonType="remove"
              buttonLabel="Remove"
              :planName="data.planName"
              @action="removePlan"
              :promoDetails="data.promodata"
            />
            <basket
              v-for="(data, i) in addonData"
              :key="i"
              title="Addon"
              :detailsHtml="data.text"
              :discountedPrice="data.finalPrice"
              :originalPrice="data.price"
              buttonType="remove"
              buttonLabel="Remove"
              :planName="data.planName"
              @action="removeAddon(i)"
            />
            <p class="mb-2 mt-2 text-success" v-if="basketData.shippingCharge">
              ✅ Shipping Charge:
              {{ basketData.shippingCharge }}
            </p>
            <div class="text-gray-700 font-semibold">
              {{ $t("customers.label.TotalPrice") }}
              <span style="color: green"
                >{{
                  planData.length && planData[0].currencySymbol
                    ? planData[0].currencySymbol
                    : ""
                }}
                {{ totalPrice.toFixed(2) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row justify-end">
      <span class="mr-2 mt-2">
        <vs-button @click="nextTab">
          {{ $t("customers.label.next") }}
        </vs-button>
      </span>
    </div>
  </div>
</template>

<script>
import basket from "@/components/basket.vue";
import PricingCard from "./PlanInfoCardConponent.vue";
import { mapState } from "vuex";
import Timer from "@/components/Timer.vue";
export default {
  data() {
    return {
      searchQuery: "",
      selectedCategories: {},
      oneTime: true,
      recurring: false,
      voice: true,
      data: true,
      national: true,
      international: true,
      roaming: true,
      selectedTab: 0,
      highlightedPlanId: "1gb",
      contentData: [],
      selectedPlan: "",
      selectedAddon: "",
      planData: [],
      addonData: [],
      nextClicked: false,
    };
  },
  components: {
    basket,
    Timer,
    PricingCard,
  },
  computed: {
    ...mapState({
      PlanInfo: (state) => state.customerActivationNew.planData,
      basketData: (state) => state.customerActivationNew.basketData,
      CategoryData: (state) => state.customerActivationNew.categoryData,
      elapsedTime: (state) => state.customerActivationNew.elapsedTime,
    }),
    filteredPlans() {
      if (!this.searchQuery.trim()) {
        return this.PlanInfo;
      }
      const lowerCaseQuery = this.searchQuery.toLowerCase();
      return this.PlanInfo.filter((plan) => {
        const isMatch =
          plan.planCode.toLowerCase().includes(lowerCaseQuery) ||
          plan.planDescription.toLowerCase().includes(lowerCaseQuery);
        return isMatch;
      });
    },
    totalPrice() {
      let price = 0;
      for (const temp of this.addonData) {
        price += temp.finalPrice;
      }
      price +=
        (this.planData && this.planData[0] && this.planData[0].finalPrice) || 0;
      return price + (this.basketData.shippingCharge || 0);
    },
    chunkedCategoryData() {
      const chunkSize = 6; // Define how many checkboxes per row
      const chunks = [];
      for (let i = 0; i < this.CategoryData.length; i += chunkSize) {
        chunks.push(this.CategoryData.slice(i, i + chunkSize));
      }
      return chunks;
    },
  },
  methods: {
    updateElapsedTime(time) {
      this.$store.commit("customerActivationNew/setElapsedTime", time);
    },
    removeAddon(i) {
      this.addonData.splice(i, 1);
      this.selectedAddon = "";
    },
    removePlan() {
      this.planData = [];
      this.selectedPlan = "";
    },
    planSelected(plan, data, content, sel) {
      this.selectedPlan = sel;
      const planData = {
        ...content,
        ...plan,
        planName: data.planCode,
        currencySymbol: data.symbol,
        currencyCode: data.currencyCode,
        promodata: (data.promodata || []).reduce((acc, item) => {
          acc[item.contentType] = {
            promoCode: item.promoCode,
            text: item.text,
          };
          return acc;
        }, {}),
      };
      this.planData = [planData];
    },

    addonSelected(plan, data, content, p, sel) {
      this.selectedAddon = sel;

      const planData = {
        ...content,
        ...plan,
        planName: data.planCode,
      };
      this.addonData = [planData];
    },
    setPlan(data, i) {
      let planData = {};
      const pricing = data.priceDetails;
      for (const temp of this.contentData) {
        if (temp.planId == data.id && temp.type == "Feature_list") {
          planData = temp;
          break;
        }
      }
      pricing.filter((e) => e.channel == "POS");
    },
    storeBasketData() {
      const basketData = {
        ...this.basketData,
        planData: this.planData,
        addonData: this.addonData,
        selectedAddon: this.selectedAddon,
        selectedPlan: this.selectedPlan,
        totalPrice: this.totalPrice,
        timer: this.elapsedTime,
        stage: 2,
      };
      this.$store.dispatch("customerActivationNew/setBasketData", basketData);
    },
    nextTab() {
      // :disabled="!selectedPlan"
      this.nextClicked = true;
      if (this.nextClicked && !this.selectedPlan) {
        return;
      }
      this.storeBasketData();
      this.$router.push("/customers/customer_activation/customer-info");
    },
    async getPlanInfoMethod(planType) {
      const data = {
        locale: "en",
        plantype: planType,
        isprepaid: this.basketData.simType === "Prepaid" ? "Y" : "N",
        salesChannel: "POS",
        accessibleOnly: "Y",
      };

      const processedIds = new Set();
      try {
        await this.$store
          .dispatch("customerActivationNew/fetchPlanInfoAction", data)
          .then((res) => {
            const pageItems = res.data.pageItems;
            for (const x of pageItems) {
              if (processedIds.has(x.id)) continue;
              processedIds.add(x.id);
              pageItems.forEach((item) => {
                this.contentData.push(item.documentData);
              });
            }
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCategoryDataMethod() {
      try {
        await this.$store.dispatch(
          "customerActivationNew/getPlanCategoryAction"
        );
        this.CategoryData.forEach((item) => {
          this.$set(this.selectedCategories, item.mCodeValue, false);
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  created() {
    // Initialize selectedCategories with all false
  },
  watch: {
    async selectedTab(newTab) {
      this.contentData = [];
      const planType = newTab === 0 ? "BasePlan" : "AddonPlan";
      this.getPlanInfoMethod(planType);
    },
    selectedCategories: {
      deep: true,
      handler(newVal) {
        //
      },
    },
  },
  mounted() {
    this.getPlanInfoMethod("BasePlan");
    this.fetchCategoryDataMethod();
    if (this.basketData.planData) {
      this.planData = this.basketData.planData;
      this.addonData = this.basketData.addonData;
      this.selectedAddon = this.basketData.selectedAddon;
      this.selectedPlan = this.basketData.selectedPlan;
    }
    // this.fetchMonthlyDataMethod();
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
  padding: 24px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header h2 {
  font-size: 18px;
  font-weight: 500;
  color: #1a202c;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tabs {
  display: flex;
}

.plans {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.plan {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  background-color: white;
}

.plan.highlighted {
  background-color: #f0fdf4;
}

.durations {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.durations label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.durations input[type="radio"] {
  width: 16px;
  height: 16px;
  border: 2px solid #16a34a;
  accent-color: #16a34a;
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.info h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.pricing {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.price {
  font-size: 14px;
}

.discount {
  display: flex;
  align-items: center;
  gap: 8px;
}

.original-price {
  text-decoration: line-through;
  color: #6b7280;
}

.savings {
  color: #16a34a;
  font-size: 14px;
}

.contract {
  font-size: 12px;
  color: #6b7280;
}

.features {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 8px;
}

.feature svg {
  width: 16px;
  height: 16px;
  color: #16a34a;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.offer {
  font-size: 12px;
  padding: 4px 8px;
  background-color: #fef3c7;
  color: #c2410c;
  border-radius: 4px;
}

.buy {
  padding: 8px 16px;
  background-color: #f0fdf4;
  color: #16a34a;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.buy:hover {
  background-color: #e6fce8;
}

.view-tnc {
  font-size: 12px;
  color: #2563eb;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

.view-tnc:hover {
  color: #1d4ed8;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.my-search-box {
  .vs-table--search-input {
    max-width: 250px;
    height: 2.4rem;
    border-radius: 20px;
    font-size: small;
  }

  .vs-table--search {
    margin-top: 0;
  }
}

.basketSection {
  border-bottom: 1px solid #00000026;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.checkboxSection ::v-deep .con-slot-label {
  font-size: 13px;
}
</style>
